
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faDatabase, faSearch } from '@fortawesome/pro-regular-svg-icons'
import { faTruck, faPlus, faFlag, faChartPie } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from './architecture/frontend/index'

const fonts = {
  faFlag: faFlag,
  faPlus: faPlus,
  faSearch: faSearch,
  faDatabase: faDatabase,
  faBars: faBars,
  faTruck: faTruck,
  faChartPie: faChartPie,
}

const Subheader = (props) => {
  const category = props._item
  const title = category?.title
  const icon = category?.icon
  const bold = category?.bold ? '#f6fafb' : '#D2A2D3'
  const spaced = category?.spaced ? ' pt3 pb1 ' : ' pv1 '
  const onClickAction = category?.onClickAction
  const onClickValue = category.onClickValue
  const selected = category?.view === props.view?.type ? {color: '#ffe00f'} : {}
  const count = category?.count
  return (
    <div className={'w-100 ph3 fw4 white flex justify-between pointer ' + spaced }  style={{color: bold, ...selected}} 
      onClick={e => Dispatch.nextAction(onClickAction, onClickAction === 'view' ? { type: onClickValue } : onClickValue)}>
      <div className='flex items-center'>
        <FontAwesomeIcon className='f6' icon={fonts[icon]} />
        <div className='pl2 f6'>{title}</div>
      </div>
      {(count || (count === 0)) && <div className=' ph2 fw4 ml2 br3 tc' style={{paddingTop: 3, paddingBottom: 0, backgroundColor: '#841972', color: '#f6fafb', fontSize: '60%'}}>{count}</div>}
    </div>
  )
}

const Search = (props) => {
  const search = props._item
  return (
      <div className=' flex white items-center pb3'>
        <FontAwesomeIcon className='pl3 f5' icon={fonts[props._item?.icon]} />
        <form onSubmit={e => {
          e.preventDefault()
          const form = e.target;
          const element = form.elements['search'];
          const value = element.value
          Dispatch.nextAction('view', { type: 'claimTable', details: value })
          // Clear out input box value
          element.value = ''
        }}>
         <input 
            className='ml2 ph3 br4 f7 w4 bn white search' 
            style={{ outline: 'none', borderStyle: 'solid', backgroundColor: '#b151a2', paddingTop: 5, paddingBottom: 5}} 
            type="text" 
            name={'search'}
            placeholder={search?.placeholder}
            // defaultValue={}
            // onChange={}
            
          />
        </form>
      </div>
  )
}

const Header2 = (props) => {
  const index = props._index
  const title = props._item?.title
  const icon = props._item?.icon
  return (
    <div className={'w-100 pb3 mb2 flex flex-column' + (index!== 0 ? ' pt3 mt2 ' : ' ')}>
      <div className='w-100 ph3 pv3 f6 fw7 white flex helvetica items-center' style={{backgroundColor: '#6a145c'}}>
        <FontAwesomeIcon className='' icon={fonts[icon]} />
        <div className='pl2 '>{title}</div>
      </div>
    </div>
  )
}

const types = {
  Header: Header2,
  Subheader: Subheader,
  Search: Search,
}

const NavBar = (props) => {
  const sidebarWidth = props._sidebarWidth
  return (
    <div className='vh-100 overflow-y-auto pb4' style={{width:sidebarWidth, backgroundColor:'#90267f', maxHeight: props.ui?.window?.height - props.ui?.window?.header}}>
    {props.sidebar !== 'loading' && props.sidebar?.map((item,index) => {
      const Display = types[item.type]
      return (
        <div key={index}>
          <Display _index={index} _item={item} {...props} />
        </div>
      )
    })}
    </div>
  )
}

export default NavBar